export default {
  namespaced: true,

  getters: {
    insurancePlan: () => (plan) => {
      return plan?.contractType === "insurance";
    },
    isMonthDiscount: () => (lead) => {
      return typeof lead?.discount?.type === "string" ? lead.discount.type.split("_")[0] === "months" : false;
    },
    isPromotionOnMonths: (_state, getters) => (lead, offerPrice) => {
      return getters.isMonthDiscount(lead) && !!offerPrice?.recurring;
    },
    isOffered: () => (lead, offerPrice) => {
      return typeof lead?.discount?.type === "string"
        ? lead.discount.type === "months_offered" && !!offerPrice?.recurring
        : false;
    },
    isComposedItemsMutable: () => (plan) => {
      return plan?.composedProductItemsMutable !== false;
    },
  },
};
